import {BaseEntity} from "./BaseEntity";
import {SkillWithMinimumLevel} from "./EmployeeSkill";
import {StaffingComment} from "./staffing-comment";
import {Client} from "../config/Client";
import {ResourceRequestFile} from "./resource-request-file";
import {Project} from "./Project";
import {Employee} from "./Employee";
import {OfferedEmployeeStatus} from "./Enums/OfferedEmployeeStatus";
import {OfferedChangedStatus} from "./OfferedChangedStatus";

export class ResourceRequest extends BaseEntity {
	origId: number;
	requestTitle: string;
	commitmentStart: string;
	commitmentEnd: string;
	probability: number;
	optionOnFollowUpBusiness: boolean;
	client: Client;
	currentProject?: Project;
	skillDescriptionOfCustomer?: string;
	internalSkillset?: SkillWithMinimumLevel[];
	skillOperator: string;
	desiredCandidate?: string;
	offer?: string;
	requiredEmployees: number;
	notes: string;
	dispoFlag: boolean;
	dispoFlagLastChangedAt: string;
	requestingUnit: string;
	requestedBy: string;
	requestedFrom: Employee;
	compensation: number;
	currency: string;
	ratesDetails: string;
	travelExpensePolicy: string;
	scope: number;
	scopeComment: string;
	location: string;
	travelMode: string;
	requestStatus: string;
	requestType: string;
	statusComment: string;
	travelModeDetails?: string;
	staffingTag: string;
	responsibleBusinessUnit: string;
	// businessUnits == Interested Business Units in the UI
	businessUnits: string[];
	divisions: string[];
	responsibleDE?: Employee | null;
	responsibleRO?: Employee | null;
	interestedResponsible: Employee[];
	requestReceipt: string;
	answerUntil: string;
	offered: {
		employee: Employee;
		offeredStatus: OfferedEmployeeStatus;
		offeredEmployeeBu: string;
		createdByUser: string;
		enableDownload?: boolean;
	}[];
	staffingComments?: StaffingComment[];
	staffingLocation?: string[]; // backend field for countryOfStaffing
	countryOfStaffing?: string[];
	interestedStaffingComments?: StaffingComment[];
	finishingDate?: string;
	totalScope: number;
	files: ResourceRequestFile[];
	requiredLanguage: string[];
	offeredChangedStatus: OfferedChangedStatus;
}

export class ResourceRequestOverviewDTO extends BaseEntity {
	id: number;
	origId: number;
	createdAt: string;
	lastModifiedAt: string;
	requestTitle: string;
	commitmentStart: string;
	commitmentEnd?: string;
	probability: string;
	client: Client;
	currentProject?: string;
	requiredEmployees: number;
	scope: number;
	location: string;
	travelMode: string;
	msgUnit: string;
	responsibleBusinessUnit: {viewValue: string; value: string};
	businessUnits: string[];
	divisions: string[];
	responsibleDE: string;
	responsibleRO: string;
	requestReceipt: string;
	answerUntil: string;
	requestStatus: string;
	requestType: string;
	totalScope: number;
	offered: string[];
	staffingTag: string;
	dispoFlag: boolean;
	dispoFlagLastChangedAt: string;
	notes: string;
	skillDescriptionOfCustomer: string;
	staffingSkills?: StaffingSkill[];
	offer: string;
	requestedBy: string;
	role: string;
	hasUserBu: boolean;
	isFavorite: boolean;
	favoriteComment: string;
}

export interface StaffingSkill {
	skillNameDe: string;
	skillNameEn: string;
	skillNameAlt: string;
	minimumLevel: string;
}

export class ResourceRequestOverviewDTOWithInstance extends ResourceRequestOverviewDTO {
	instance: string;
}
